import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Event } from '../../model/event';
import { UserEvent } from '../../model/user.event';
import { UserEventAnswer } from '../../enum/user.event.answer';
import { EventsService } from '../../service/events.service';
import { NotificationService } from '../../service/notification.service';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';

/**
 * Painel de aceite/rejeição de convite para o TPC.
 *
 * Renderiza embutido no card do evento (`event-view`) quando o usuário
 * logado tem convite pendente pra participar do TPC daquele evento —
 * assim ele resolve o convite sem sair da página. `[embedded]="true"`
 * remove chrome próprio e vira uma seção do card do evento (padrão hoje).
 */
@Component({
  selector: 'app-tpc-invite-panel',
  templateUrl: './tpc-invite-panel.component.html',
  styleUrls: ['./tpc-invite-panel.component.scss'],
})
export class TpcInvitePanelComponent {
  @Input() event: Event;
  @Input() userEvent: UserEvent;
  /**
   * Modo "embutido": remove chrome próprio (borda, padding, margin) e
   * adiciona divisória superior — vira uma seção dentro do card pai
   * (ex.: dentro do `mat-card` do evento em event-view). Default false
   * = renderiza como card standalone.
   */
  @Input() embedded = false;
  /** Emite após o backend confirmar a resposta — o pai pode recarregar o estado. */
  @Output() answered = new EventEmitter<UserEventAnswer>();

  submitting = false;

  constructor(
    private eventsService: EventsService,
    private notificationService: NotificationService,
    private dialog: MatDialog,
  ) {}

  accept(): void { this.confirmAndSubmit(UserEventAnswer.ACCEPTED); }
  reject(): void { this.confirmAndSubmit(UserEventAnswer.REJECTED); }

  private confirmAndSubmit(answer: UserEventAnswer): void {
    const ref = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        title: `confirm-tpc-invite.dialog.${answer}.title`,
        content: `confirm-tpc-invite.dialog.${answer}.content`,
      }
    });
    ref.afterClosed().subscribe(confirmed => {
      if (!confirmed) { return; }
      this.submit(answer);
    });
  }

  private submit(answer: UserEventAnswer): void {
    if (!this.userEvent) { return; }
    this.submitting = true;
    this.eventsService.confirmInvitation(
      this.userEvent.id,
      answer.toUpperCase() as UserEventAnswer,
    ).subscribe(
      () => {
        this.notificationService.notify('admin.event.people.tpc.sent-tpc-invitation-response');
        this.answered.emit(answer);
      },
      () => { this.submitting = false; },
    );
  }
}
